<!-- Navigation -->
    <header class="nav-type-2" (keydown.escape)="closeMenu(menuToggle)">
        <nav class="navbar navbar-static-top">
            <div class="navigation">
                <div class="container-fluid relative">                   
                    <div class="row navbar-header">
                        <div class="navbar-header-toggle">
                           <!-- Logo -->
                           <div class="logo-container">
                                <div class="logo-wrap local-scroll">
                                    <a routerLink="/" (click)="closeMenu()">
                                        <picture>
                                            <source srcset="assets/img/logoCentralGas.webp" type="image/webp">
                                            <source srcset="assets/img/logoCentralGas.png" type="image/png">
                                            <img src="assets/img/logoCentralGas.png" alt="CentralGas — inicio" width="180" height="79"/>
                                        </picture>
                                    </a>
                                </div>
                                
                            </div>   

                                <div class="toggle-container">
                                <button #menuToggle type="button" class="navbar-toggle" (click)="toggleDropdown()"
                                    [attr.aria-expanded]="isMenuOpen" aria-controls="navbar-collapse">
                                <span class="sr-only">Menú principal</span>
                                <span class="icon-bar" aria-hidden="true"></span>
                                <span class="icon-bar" aria-hidden="true"></span>
                                <span class="icon-bar" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                        <!-- end navbar-header -->

                        <div class="col-md-12 nav-wrap"
                        [class.nav-hidden]="!isMenuOpen">
                             <div id="navbar-collapse">

                                <ul class="nav navbar-nav">
                                    <li class="quienesSomos">
                                        <a [routerLink]="['']" [fragment]="'quienesSomos'" (click)="closeMenu()"> ¿Quiénes somos?</a>
                                    </li>
                                    
                                    <li class="servicios">
                                        <a [routerLink]="['']" [fragment]="'servicios'" (click)="closeMenu()">Servicios</a>
                                    </li>

                                    <li class="trabajos">
                                        <a [routerLink]="['']" [fragment]="'trabajos'" (click)="closeMenu()"> Trabajos</a>
                                    </li>
                                        
                                    <li class="instalacionesDomesticas">
                                        <a [routerLink]="['']" [fragment]="'instalacionesDomesticas'" (click)="closeMenu()"> Instalaciones Domésticas</a>
                                    </li>

                                    <li class="centralgasIndustrial">
                                        <a [routerLink]="['']" [fragment]="'centralgasIndustrial'" (click)="closeMenu()">Centralgas Industrial</a>
                                    </li>

                                    <li class="contacto">
                                        <a [routerLink]="['']" [fragment]="'contacto'" (click)="closeMenu()">Contacto</a>
                                    </li>
                                    <li class="grupo-sunflower">
                                        <a href="https://www.sunflowerenergias.es" target="_blank" rel="noopener noreferrer" (click)="closeMenu()">
                                            <picture>
                                                <source srcset="assets/img/logoSunflower.webp" type="image/webp">
                                                <source srcset="assets/img/logoSunflower.png" type="image/png">
                                                <img src="assets/img/logoSunflower.png" alt="Grupo Sunflower" width="106" height="30"/>
                                            </picture>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                     
                        <!-- end col -->
                    </div>
                    <!-- end row -->
                </div>
                <!-- end container -->
            </div>
            <!-- end navigation -->
        </nav>
        <!-- end navbar -->
    </header>
<!-- end navigation -->
